/**
 * Snippet: Emoji
 * ------------------------------------------------------------------------------
 * This file stops all emojis from become italicized.
 *
 * @namespace blog
 */

import $ from 'jquery';

theme.convertEmojis = (() => {
  const emoji = [
    '✌',
    '😂',
    '😝',
    '😁',
    '🙂',
    '😱',
    '👉',
    '🙌',
    '🍻',
    '🔥',
    '🌈',
    '☀',
    '🎈',
    '🌹',
    '💄',
    '🎀',
    '⚽',
    '🎾',
    '🏁',
    '😡',
    '👿',
    '🐻',
    '🐶',
    '🐬',
    '🐟',
    '🍀',
    '👀',
    '🚗',
    '🍎',
    '💝',
    '💙',
    '👌',
    '❤',
    '😍',
    '😉',
    '😓',
    '😳',
    '💪',
    '💩',
    '🍸',
    '🔑',
    '💖',
    '🌟',
    '🎉',
    '🌺',
    '🎶',
    '👠',
    '🏈',
    '⚾',
    '🏆',
    '👽',
    '💀',
    '🐵',
    '🐮',
    '🐩',
    '🐎',
    '💣',
    '👃',
    '👂',
    '🍓',
    '💘',
    '💜',
    '👊',
    '💋',
    '😘',
    '😜',
    '😵',
    '🙏',
    '👋',
    '🚽',
    '💃',
    '💎',
    '🚀',
    '🌙',
    '🎁',
    '⛄',
    '🌊',
    '⛵',
    '🏀',
    '🎱',
    '💰',
    '👶',
    '👸',
    '🐰',
    '🐷',
    '🐍',
    '🐫',
    '🔫',
    '👄',
    '🚲',
    '🍉',
    '💛',
    '💚',
    '💓',
    '💕',
    '💞',
    '💗',
  ];

  $.each(emoji, (index, value) => {
    $(`p:contains(${value})`).html((_, html) => {
      const regex = new RegExp(value, 'g');
      return html.replace(regex, `<span class="emoji">${value}</span>`);
    });

    $(`.testimonials__quote:contains(${value})`).html((_, html) => {
      const regex = new RegExp(value, 'g');
      return html.replace(regex, `<div class="emoji">${value}</div>`);
    });
  });
})();
